module.exports = __webpack_public_path__ + "static/media/gym9.7f968acb.png";